import React from 'react'

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx'

import { Drawer, Divider } from '@material-ui/core';

import Profile from './Components/Profile/Profile';
import Premium from './Components/Premium/Premium';
import SideBarNavigation from './Components/SideBarNavigation/SideBarNavigation'
import SideBarHeader from './Components/SideBarHeader/SideBarHeader'

import PerfectScrollbar from 'react-perfect-scrollbar';


import { useSelector, shallowEqual } from 'react-redux';


const useStyles = makeStyles(theme => ({
    drawer: {
        width: 240,
        [theme.breakpoints.up('lg')]: {
            marginTop: 64,
            height: 'calc(100%- 64px)'
        }
    },
    rootDiv: {
        backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2),
        marginBottom: 128,
    },
    divider: {
        // margin: '8px 0px'
        margin: theme.spacing(2, 0)
    },
    topSpace: {
        paddingTop: 56,//small sm
        [theme.breakpoints.up('sm')]: {
            paddingTop: 64 + 16
        },
    }
}))

function SideBar(props) {
    const { open, className, onCloseHandler, variant, ...rest } = props
    const classes = useStyles()


    // const useTranslations = () => useSelector(state => state.navs.navIndex);
    const useTranslations = () => useSelector(state => {
        console.log("useTranslations...", state.navs.navIndex);
       return state.navs.navIndex
    }); //, []);

    const navigations = useTranslations();


    return (
        <Drawer anchor="left"
            open={open}
            variant={variant}
            classes={{ paper: classes.drawer }}
        >
            <PerfectScrollbar>
                <SideBarHeader onClose={onCloseHandler} variantType={variant} />
                <div
                    {...rest}
                    className={clsx(
                        {
                            [classes.rootDiv]: true,
                            [className]: true,
                            [classes.topSpace]: variant === 'temporary' ? true : false
                        }
                    )}
                >


                    <Profile />
                    <Divider className={classes.divider} />


                    {navigations && navigations.length > 0 && <SideBarNavigation pages={navigations} />}


                    <Premium />
                </div>
            </PerfectScrollbar>
        </Drawer>
    )
}


SideBar.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onCloseHandler: PropTypes.func,
    variant: PropTypes.string.isRequired
}



export default SideBar

